// gkc_hash_code : 01FJGW9AB4VKN1PM0CVCZY1PTE
export enum LiveStreamStatus {
  BEFORE = 0,
  ONLIVE = 1,
  END = 2,
}

export enum CameraSetting {
  vertical = "vertical",
  horizontal = "horizontal",
}

export const limitQuery = 10000;

export enum CommentStatus {
  AVAILABLE = 0,
  HIDE = 1,
  BLOCK = 2,
}

export enum ShopType {
  PLACEHOLDER = "選択して下さい",
  COLORMESHOP = "colormeshop",
  MAKESHOP = "makeshop",
  EXTERNALSHOP = "external_site",
  SHOPIFYSHOP = "shopifyshop",
  BASESHOP = "baseshop",
}

export enum RecordStatus {
  AVAILABLE = 0,
  DELETED = 1,
}

export enum RehearsalCartIn {
  NOT_REHEARSAL = "0",
  IS_REHEARSAL = "1",
}

export enum StickyComment {
  NOT_STICKY = 0,
  IS_STICKY = 1,
}

export enum FeartureProduct {
  NOT_FEARTURE = 0,
  IS_FEARTURE = 1,
}

export enum StoragedManageStatus {
  AUTO = 0,
  OFF = 2,
}
